module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-266.a552bb72.jpg";